import Card from '../ui/Card'
import { problemsContent } from '../../data/landing-content'

export default function ProblemCards() {
  return (
    <section className="mt-22">
      <div className="mb-11">
        <h2 className="text-[clamp(2rem,2.8vw+1rem,2.8rem)] tracking-[-0.03em] font-bold m-0 mb-4">
          {problemsContent.sectionTitle}
        </h2>
        <p className="text-ink-soft leading-relaxed max-w-[520px] m-0">
          {problemsContent.sectionDescription}
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {problemsContent.cards.map((card, idx) => (
          <Card key={idx} variant="muted">
            <h3 className="text-[1.15rem] font-semibold m-0 mb-2.5">
              {card.title}
            </h3>
            <p className="text-ink-soft leading-[1.55] m-0">
              {card.description}
            </p>
          </Card>
        ))}
      </div>
    </section>
  )
}
